module.exports = __webpack_public_path__ + "static/androidBannerChecks-895dc8eacb198836137467ec9c43f0f8.png";